
export function ajaxHandler(error) {

    if(!error.response){
        console.log(error);
        window.Materialize.toast("No se ha podido establecer conexión con el servidor.", 3000);
        return false;
    }

    let response = error.response;

    if (!(response.hasOwnProperty('status'))) {
        return false;
    }

    let status = response.status;

    if (status === 400) {
        let keys = Object.keys(response.data);
        let details = [];

        for (let i in keys) {
            details.push({
                key: keys[i],
                text: response.data[keys[i]]
            });
        }
        let text = ``;
        details.map(d => {
            return text = text + `${d.key}: ${d.text} \n`
        });

        return details;
    }

    if(status === 401){
        window.Materialize.toast("Usuario no autenticado.", 3000);
        localStorage.clear();
        window.location = '/';
        return false;
    }

    if(status === 403){
        window.Materialize.toast("Acceso denegado", 3000);
        return false;
    }

    if(status === 404){
        window.Materialize.toast("Ruta no encontrada.", 3000);
        return false;
    }

    if(status === 500){
        window.Materialize.toast("Error en el servidor.", 3000);
        return false;
    }

    let msg = `Error no esperado: ${status}`;
    window.Materialize.toast(msg, 3000);
    return false;
}


// WEBPACK FOOTER //
// ./src/utils/errors.js